import { render, staticRenderFns } from "./SignatureModal.vue?vue&type=template&id=b53df4fa"
import script from "./SignatureModal.ts?vue&type=script&lang=ts&external"
export * from "./SignatureModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports